import React from 'react';
import styles from './WelcomeLogo.module.css';
import Logo from '@assets/images/Logo.svg';

interface WelcomeLogoProps {
    isVisible: boolean;
}

export const WelcomeLogo: React.FC<WelcomeLogoProps> = ({ isVisible }) => {
    return (
        <div
            className={`d-flex justify-content-center align-items-center vh-100 ${isVisible ? styles.show : styles.hide}`}
            style={{ backgroundColor: '#1F2E55' }}>
            <img src={Logo} alt="Liga-T Logo" />
        </div>
    );
};
